const { sessionStorage } = require('dibs-browser-storage');

/**
 * Sets a matchmakerReferrer to a session storage on "Designer Connection" link click.
 */
function setMatchmakerReferrer(label) {
    sessionStorage.setItem('matchmakerReferrer', label);
}

module.exports = { setMatchmakerReferrer };
